import React from "react";
import GallerySectionHeading from "./GallerySectionHeading";
import GalleryLightbox from "./GalleryLightbox";
import useLightbox from "../hooks/useLightbox";
import "../styles/GallerySections.css";
import "../styles/MasonryGallerySection.css";

/*
 * Layout 3 — Masonry columns.
 * CSS multi-column layout; each image keeps its natural aspect ratio
 * (no cropping), producing the classic staggered Pinterest-style look.
 */
export default function MasonryGallerySection({ items, eyebrow, heading, sub }) {
  const { activeIndex, activeItem, open, close, showPrev, showNext } = useLightbox(items);

  return (
    <section className="tp-section tp-gallery">
      <div className="tp-container">
        <GallerySectionHeading eyebrow={eyebrow} heading={heading} sub={sub} />

        <div className="tp-masonry__grid">
          {items.map((item, index) => (
            <button
              type="button"
              key={item.id}
              className="tp-masonry__item"
              onClick={() => open(index)}
              aria-label={`View ${item.title} full size`}
            >
              <img src={item.image} alt={item.title} loading="lazy" />
              <span className="tp-masonry__caption">{item.title}</span>
            </button>
          ))}
        </div>
      </div>

      <GalleryLightbox
        items={items}
        activeIndex={activeIndex}
        activeItem={activeItem}
        onClose={close}
        onPrev={showPrev}
        onNext={showNext}
      />
    </section>
  );
}
